export enum BatchCorrectionAction {
    ADD = 0,
    REMOVE
}

export const numberToEnum = (value: number) : BatchCorrectionAction => {
    if (value == 1)
        return BatchCorrectionAction.REMOVE;

    return BatchCorrectionAction.ADD;
};